import React from 'react';
import StatusTag from 'core/components/StatusTag';
import {
  PatientAuthorizationUtilizationState,
} from 'dtos/patientAuthorizationUtilizationState';
import {
  getAuthorizationStatusLabel,
} from 'views/EMR/components/Authorizations/utils';

type Props = {
  status: PatientAuthorizationUtilizationState;
  className?: string;
};

export default function AuthorizationStatusBadge({ status, className }: Props) {
  return (
    <StatusTag
      value={getAuthorizationStatusLabel(status)}
      className={className}
      classes={status === PatientAuthorizationUtilizationState.Upcoming ? {
        root: '!bg-blue-100',
        value: '!text-blue-700',
      } : undefined}
      statusMap={{
        success: PatientAuthorizationUtilizationState.Available,
        pending: PatientAuthorizationUtilizationState.Upcoming,
        off: PatientAuthorizationUtilizationState.Expired,
        error: PatientAuthorizationUtilizationState.Exhausted,
        inprogress: getAuthorizationStatusLabel(PatientAuthorizationUtilizationState.PartlyExhausted),
      }}
    />
  );
}
